<template>
  <button class="back-button" @click.stop="goBack">
    <!-- <img src="@/images/icons/chevron-left-solid.svg" /> -->
    <span>TERUG</span>
  </button>
</template>

<script>
export default {
  props: {},
  methods: {
    goBack() {
      if (this.$route.params.productId) {
        this.$router.push({
          name: 'printStoreCollection',
          params: {
            categoryId: this.$route.params.categoryId,
            collectionId: this.$route.params.collectionId
          }
        })
      } else if (this.$route.params.packageId) {
        this.$router.push({
          name: 'printStoreCategory',
          params: { categoryId: this.$route.params.categoryId }
        })
      } else if (this.$route.params.collectionId) {
        this.$router.push({
          name: 'printStoreCategory',
          params: { categoryId: this.$route.params.categoryId }
        })
      } else if (this.$route.params.categoryId) {
        this.$router.push({ name: 'printStore' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back-button {
  position: relative;
  padding: 0;
  margin-right: 4px;
  white-space: nowrap;

  span {
    font-size: 11px;
    font-weight: 500;
    color: var(--sub-color);
  }

  svg {
    width: 9px;

    path,
    rect {
      fill: var(--sub-color);
    }
  }
}
</style>
